import eggplantInvoltini from './eggplantInvoltini';
import sorghumGlazedBranzino from './sorghumGlazedBranzino';
import cacioEPepe from './cacioEPepe';
import steakAndRisotto from './steakAndRisotto';
import mushroomPotPie from './mushroomPotPie';

const recipes = {
  eggplantInvoltini,
  sorghumGlazedBranzino,
  cacioEPepe,
  mushroomPotPie,
  steakAndRisotto
};

export const getRecipes = () => Object.values(recipes);
export const getRecipe = (recipe) => recipes[recipe];
export const getSeason = (season) =>
  getRecipes().filter((v) => v.season === season);

export default recipes;
